<template>
    <div id="clgl-body" ref="gwapElement">
        <BlockFrame :header="{ title: appletData.name, icon: appletData.icon, more: true, code: 'clgl_home_index.svg' }">
            <div class="ycjl_main">
                <div class="items">
                    <div v-for="item in listData" :key="item.id" class="item">
                        <div class="item_top">
                            <div class="left">
                                <div class="img">
                                    <img src="" alt="" />
                                </div>
                                <div class="msg">
                                    <span>{{ item.flVehPlate }}</span>
                                    <span style="display: flex; align-items: flex-end; flex-direction: row">
                                        <svg-icon icon-class="clgl_gr" style="width: 20px; height: 20px" />
                                        <span>{{ item.flCreator }}&nbsp;&nbsp; {{ loginUser.personMobile }}</span>
                                    </span>
                                    <span style="display: flex; align-items: flex-end; flex-direction: row">
                                        <svg-icon icon-class="clgl_sj" style="width: 20px; height: 20px" />
                                        <span>
                                            {{ item.createDate }}
                                            <span v-text-lbl="'common.to'">至</span>
                                            {{ item.returnDate }}
                                        </span>
                                    </span>
                                </div>
                            </div>
                            <div class="right">
                                <span v-text-lbl="'ArrivalLocation'" class="didian">抵达地点</span>
                                <span class="vdidian">{{ item.flDst }}</span>
                            </div>
                        </div>
                        <div class="item_bottom">
                            <div class="flMemo">{{ item.flMemo }}</div>
                            <div class="flMemo">
                                <div v-text-lbl="'Apply'" class="dv1" :time="item.flCreateDate | timeformat">申请于 {{ item.flCreateDate | timeformat }}</div>
                                <div v-text-lbl="'status'" class="dv2" :status="statusformat(item.status)">状态 {{ statusformat(item.status) }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </BlockFrame>
    </div>
</template>

<script>
const moment = require('moment')
import { mapGetters } from 'vuex'

export default {
    // import引入的组件需要注入到对象中才能使用
    name: 'Gwap',
    filters: {
        timeformat(val) {
            if (val) {
                return moment(val).format('YYYY年MM月DD日 HH:mm')
            }
        }
    },
    props: {
        title: { type: String, default: '' },
        appletData: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            i18npkg: 'clgl',
            moduleCode: 'portlet',
            base_api: process.env.VUE_APP_BASE_API,
            listData: []
        }
    },
    computed: {
        ...mapGetters(['routes', 'loginUser'])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        debugger
        this.$options.components['BlockFrame'] = this.$loadComponent('@/wapp/common/components/BlockFrame/index')

        this.base_api = process.env.VUE_APP_BASE_API
        console.log('loginUserloginUser', this.loginUser)
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.getData()
        this.title = this.title || this.$tx('clgl.portlet.gwap', '公务安排')
    },
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {}, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    activated() {},
    // 方法集合
    methods: {
        // 获取车辆数据
        async getData() {
            const param = {
                pageNum: 1,
                pageSize: 4,
                urlsearch: `orgCode:${this.loginUser.orgCode};status:2,3,4;creatorId:${this.loginUser.personId}`,
                orderBy: 'flCreateDept asc'
            }
            const res = await this.$app.listdata('/clgl/sendcar/listdata', param)
            if (res.code === 'success') {
                this.listData = res.body.pageInfo.list
                console.log(' this.listData===', this.listData)
                if (this.listData.length) {
                    this.listData.forEach((item) => {
                        if (item.flCreateDate) {
                            item.createDate = moment(item.flCreateDate).format('YYYY年MM月DD日 HH:mm')
                        }
                        if (item.returnTime) {
                            item.returnDate = moment(item.returnTime).format('MM月DD日 HH:mm')
                        }
                    })
                }
            }
        },
        statusformat(val) {
            var str = ''
            switch (val) {
                case 1:
                    str = this.$tx('clgl.portlet.PendingVehicle', '待派车')
                    break
                case 2:
                    str = this.$tx('clgl.portlet.SentCar', '已派车')
                    break
                case 3:
                    str = this.$tx('clgl.portlet.OutCar', '出车中')
                    break
                case 4:
                    str = this.$tx('clgl.portlet.ReturnedCar', '已还车')
                    break
                case 5:
                    str = this.$tx('clgl.portlet.Rejected', '已拒绝')
                    break
                case 9:
                    str = this.$tx('clgl.portlet.Cancelled', '已取消')
                    break
                case 0:
                    str = this.$tx('clgl.portlet.AlreadyBooked', '已预约')
                    break
                default:
                    break
            }
            return str
        }
    }
}
</script>
<style lang='scss' scoped>
// @import url(); 引入公共css类
#clgl-body {
    width: 100%;
    height: 100%;
    .ycjl_main {
        width: 100%;
        height: 100%;
        padding: 10px 15px;
        overflow: hidden;
        .items {
            display: flex;
            -webkit-box-pack: justify;
            -ms-flex-pack: justify;
            justify-content: space-between;
            width: 100%;
            height: 100%;
            flex-wrap: wrap;
            align-content: space-between;
            .item {
                width: 49%;
                height: 133px;
                border: 1px solid #eee;
                border-radius: 5px;
                padding: 5px;
                .item_top {
                    width: 100%;
                    height: 50%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .left {
                        display: flex;
                        align-items: center;
                        height: 100%;
                        .img {
                            width: 120px;
                            height: 100%;
                            border: 1px solid #eee;
                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }
                        .msg {
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            height: 100%;
                            margin-left: 10px;
                        }
                    }
                    .right {
                        display: flex;
                        flex-direction: column;
                        .didian {
                            color: #9b9b9b;
                        }
                        .vdidian {
                            color: #74b4e9;
                        }
                    }
                }
                .item_bottom {
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    height: 50%;
                    .flMemo {
                        width: 100%;
                        height: 100%;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        -webkit-line-clamp: 1;
                        -webkit-box-orient: vertical;

                        .dv2 {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                        }
                    }
                }
            }
        }
    }
}
</style>
